<template>
  <div class="events-add">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
        <q-card-section class="card-content">
          <!-- <div v-if="fields.type === 'Donation' && user.referrer">
            <div class="referrer" v-if="user.referrer">You've been referred by <strong>{{ user.referrer.ReferralCode }}</strong>. If you want to change, Just click Input Referrer.</div>
            <div class="change-referrer" @click="disableReferrer = false">Input Referrer</div>
          </div> -->
          <q-select
            square
            outlined
            v-model="fields.type"
            label="Ticket Type"
            :options="sections"
            color="white"
            label-color="white"
            outline-color="white"
            input-style="font-color: white;"
            :error="v$.fields.type"
            dark
            input-class="font-color: white"
            popup-content-style="color: white;"
            error-message="Event Type is required"
          />
          <q-input
            square
            outlined
            label="Reference Number"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.referenceNumber"
            @update:model-value="(e) => fields.referenceNumber = e"
            @blur="v$.fields.referenceNumber.$touch()"
            :error="v$.fields.referenceNumber.$error"
            error-message="Reference Number is required"
            v-if="fields.type === 'Donation'"
          />
          <q-input
            square
            outlined
            label="Amount"
            type="number"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.amount"
            @update:model-value="(e) => fields.amount = e"
            @blur="v$.fields.amount.$touch()"
            :error="v$.fields.amount.$error"
            error-message="Amount is required"
            v-if="fields.type === 'Donation'"
          />
          <q-input
            square
            outlined
            label="Referrer"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.referrer"
            @update:model-value="(e) => fields.referrer = e"
            hint=""
            v-if="fields.type === 'Donation' && !user.referrer"
          />
          <q-input
            square
            outlined
            label="Title"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.title"
            @update:model-value="(e) => fields.title = e"
            @blur="v$.fields.title.$touch()"
            :error="v$.fields.title.$error"
            error-message="Title is required"
            v-if="fields.type !== 'Donation'"
          />
          <q-input
            square
            outlined
            label="Description"
            color="white"
            label-color="white"
            type="textarea"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.description"
            @update:model-value="(e) => fields.description = e"
            @blur="v$.fields.description.$touch()"
            :error="v$.fields.description.$error"
            error-message="Description is required"
            v-if="fields.type !== 'Donation'"
          />
          <q-file
            square
            dark
            outlined
            v-model="image"
            label="Pick Proof"
            @blur="v$.fields.image.$touch()"
            :error="v$.fields.image.$error"
            @update:model-value="handleUpload()"
            error-message="Image is required"
          />

          <div v-if="imageUrl">
            <q-img
              :src="imageUrl"
              spinner-color="white"
            />
          </div>
        <q-btn class="events-add-btn" label="Submit" @click="submit"/>
      </q-card-section>
    </q-card>

    <q-card class="my-card-details" v-if="getDonationDetails.length && fields.type === 'Donation'">
      <q-card-section class="card-section">
        <div class="card-title">Donation Details</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <span>{{ message }}</span>
        <div class="info">
          <div class="col-item" v-for="(column, index) in donationImageColumn" :key="index">
            <div v-for="(details) in column" :key="details.ID">
              <img :src="details.Info" style="width: 100%;"/>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { requiredIf, required } from "vuelidate/lib/validators";
import { useVuelidate } from '@vuelidate/core'
import { mapGetters } from 'vuex';

export default {
  name: 'CreateTicket',
  props: {
    module: {
      require: true,
      type: Object
    }
  },
  components: {
  },
  setup () {
    return { v$: useVuelidate() }
  },
  validations () {
    return {
      fields: {
        description: {
          required: requiredIf(function() {
            return this.fields.type !== 'Donation'
          })
        },
        title: {
          required: requiredIf(function() {
            return this.fields.type !== 'Donation'
          })
        },
        type: {
          required
        },
        amount: {
          required: requiredIf(function() {
            return this.fields.type === 'Donation'
          })
        },
        referenceNumber: {
          required: requiredIf(function() {
            return this.fields.type === 'Donation'
          })
        },
        image: {
          required
        }
      }
    }
  },
  data () {
    return {
      fields: {
        description: null,
        title: null,
        referenceNumber: null,
        amount: 0,
        type: 'Bug',
        image: null,
        referrer: null
      },
      disableReferrer: true,
      sections: ['Bug', 'Suggestions', 'Donation'],
      imageUrl: null,
      image: null,
      column: 2
    }
  },
  computed: {
    ...mapGetters({
      getDonationDetails: 'home/getDonationDetails',
      user: 'user/getUser'
    }),
    donationImageColumn () {
      let column = []

      if (this.getDonationDetails) {
        const donationDetails = this.getDonationDetails

        if (!donationDetails) return []

        const mid = Math.ceil(donationDetails.length / 2)

        for (let col = 0; col < 2; col++) {
          column.push(donationDetails.slice(col * mid, col * mid + mid))
        }
      }

      return column
    },
    message () {
      return process.env.VUE_APP_DONATE_MESSAGE
    }
  },
  mounted () {
    if (this.user.referrer) this.fields.referrer = this.user.referrer.ReferralCode
  },
  methods: {
    ...mapActions({
      createTicket : 'user/createTicket',
    }),
    async handleUpload () {
      if (this.image) {
        this.imageUrl = URL.createObjectURL(this.image);
      }

      await this.createBase64Image(this.image)
    },
    createBase64Image: function(FileObject) {
      const reader = new FileReader();

      reader.onload = (event) => {
        this.fields.image = event.target.result;
      }

      reader.readAsDataURL(FileObject);
    },
    async submit () {
      this.v$.fields.$touch();

      if (this.v$.fields.$invalid) {
        return
      }

      this.$q.loading.show();
      
      await this.recaptchaLoad('createticket')

      await this.createTicket(this.fields)
        .then(async (response) => {
          await this.recaptchaLoad('createticket')

          this.resetFields()
          
          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })

          this.$q.loading.hide()
        })
        .catch((error) => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })

          this.$q.loading.hide();
        })
    },
    resetFields() {
      this.v$.fields.$reset()

      this.fields = {
        description: null,
        title: null,
        referenceNumber: null,
        amount: 0,
        type: 'Bug',
        image: null
      }

      this.imageUrl = null
    }
  }
}
</script>
<style lang="scss">
.events-add {
  .my-card {
    background-color: $backgroundHeader;
    margin-bottom: 16px;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }

    .referrer {
      color: white;
    }

    .change-referrer {
      color: blue;
      cursor: pointer;

    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .events-add-btn {
      background-color: #FFC108;
    }
  }

  .my-card-details {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
      color: white;
    }

    span {
      background-color: $background;
      color: white;
    }

    .card-content {
      background-color: $background;

      .info {
        display: flex;
        grid-template-rows: 1fr 1fr;
        gap: 16px;
      }
    }
  }
}
</style>